export default __webpack_public_path__ + "static/a.moore-ac0f165b797a217247e23be813ccd45d.png";